import { Calendar, MessageSquare, FileText, Clock, Globe, Search, BarChart3 } from 'lucide-react';

const StatCard = ({ label, value, icon: Icon, bgClass, iconClass, onClick, testId }) => (
  <button onClick={onClick} className="bg-white rounded-lg shadow p-6 text-left hover:shadow-md transition-shadow" data-testid={testId}>
    <div className="flex items-center justify-between">
      <div>
        <p className="text-sm text-gray-500">{label}</p>
        <p className="text-3xl font-bold text-gray-900">{value}</p>
      </div>
      <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${bgClass}`}>
        <Icon className={`w-6 h-6 ${iconClass}`} />
      </div>
    </div>
  </button>
);

export const Dashboard = ({ stats, setActiveMenu }) => (
  <div className="space-y-6" data-testid="admin-dashboard">
    <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <StatCard label="Total Bookings" value={stats.bookings || 0} icon={Calendar} bgClass="bg-blue-100" iconClass="text-blue-600" onClick={() => setActiveMenu('bookings')} testId="stat-bookings" />
      <StatCard label="Messages" value={stats.messages || 0} icon={MessageSquare} bgClass="bg-green-100" iconClass="text-green-600" onClick={() => setActiveMenu('messages')} testId="stat-messages" />
      <StatCard label="Blog Posts" value={stats.posts || 0} icon={FileText} bgClass="bg-purple-100" iconClass="text-purple-600" onClick={() => setActiveMenu('posts')} testId="stat-posts" />
      <StatCard label="Pending" value={stats.pending || 0} icon={Clock} bgClass="bg-orange-100" iconClass="text-orange-600" onClick={() => setActiveMenu('bookings')} testId="stat-pending" />
    </div>
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-lg font-semibold mb-4">Quick Actions</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[
          { icon: Globe, label: 'View Site', href: 'https://13cabsbook.com.au' },
          { icon: Search, label: 'Sitemap', href: 'https://13cabsbook.com.au/api/sitemap.xml' },
          { icon: FileText, label: 'Robots.txt', href: 'https://13cabsbook.com.au/api/robots.txt' },
          { icon: BarChart3, label: 'Search Console', href: 'https://search.google.com/search-console' },
        ].map((action) => (
          <a key={action.label} href={action.href} target="_blank" rel="noreferrer" className="flex flex-col items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
            <action.icon className="w-8 h-8 text-primary mb-2" />
            <span className="text-sm text-gray-600">{action.label}</span>
          </a>
        ))}
      </div>
    </div>
  </div>
);
